import script from "./MessageEmojiReactionsPanelItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageEmojiReactionsPanelItem.vue?vue&type=script&setup=true&lang=ts"

import "./MessageEmojiReactionsPanelItem.vue?vue&type=style&index=0&id=0effe94c&lang=scss"

const __exports__ = script;

export default __exports__